import React from 'react';
import { FormSelectOption } from './FormTypes';
import { FormControl, FormLabel, Select, Text, VStack } from '@chakra-ui/react';
import { FormikProps } from 'formik/dist/types';
import { path } from 'ramda';

export interface FormikSelectProps {
  options: Array<FormSelectOption>;
  valueType?: string | number;
  label?: string;
  name: string;
  formik: FormikProps<any>;
  onChange?: (name: string, value: string | number) => void;
  idx?: number | string;
  property?: string;
  required?: boolean;
}

export const FormikSelect = (props: FormikSelectProps): JSX.Element => {
  const { options, label, name, formik, valueType, onChange, idx, property, required } = props;
  const propertyPath = property ? '.' + property : '';
  const errorInPath = path(name.split('.'), formik.errors);

  return (
    <FormControl>
      {label && (
        <FormLabel fontSize={'sm'}>
          {label}
          {!!required ? '*' : ''}
        </FormLabel>
      )}
      <VStack alignItems={'flex-start'}>
        <Select
          isInvalid={
            (typeof formik.errors[name] === 'object' &&
              typeof idx !== 'undefined' &&
              // @ts-ignore
              formik.errors[name][idx]) ||
            (!!formik.errors[name] && typeof formik.errors[name] === 'string') ||
            (errorInPath && name.split('.').length > 1)
          }
          name={typeof idx !== 'undefined' ? `${name}[${idx}]${propertyPath}` : name}
          value={
            typeof idx !== 'undefined'
              ? property
                ? formik.values[name][idx][property]
                : formik.values[name][idx]
              : formik.values[name]
          }
          onChange={e => {
            const value = valueType === 'number' ? parseInt(e.target.value) : e.target.value;
            const modifiedName =
              typeof idx !== 'undefined' ? `${name}[${idx}]]${propertyPath}` : name;

            if (onChange) {
              onChange(modifiedName, value);
            } else {
              formik.setFieldValue(modifiedName, value);
            }
          }}>
          {options.map((option, idx) => {
            return (
              <option key={idx} value={option.id}>
                {option.title}
              </option>
            );
          })}
        </Select>
        {!!formik.errors[name] && typeof formik.errors[name] === 'string' && (
          <Text color={'red.500'}>{formik.errors[name]}</Text>
        )}

        {!!formik.errors[name] &&
          typeof idx !== 'undefined' &&
          typeof formik.errors[name] === 'object' &&
          // @ts-ignore
          formik.errors[name][idx] && <Text color={'red.500'}>{formik.errors[name][idx]}</Text>}
        {errorInPath && name.split('.').length > 1 && (
          // @ts-ignore
          <Text color={'red.500'}>{errorInPath}</Text>
        )}
      </VStack>
    </FormControl>
  );
};
